import { ca } from '@cian/analytics';

export function trackLogoutClick() {
  ca('eventSite', {
    name: 'oldevent',
    category: 'main_page',
    action: 'top_menu',
    label: 'logout',
  });
}
